import { api, wrapParams } from '../../api';
import { SHOW_LOADING, HIDE_LOADING } from './types/loadingTypes';

import { showToast } from './toastrActions';
import { getAuthUser } from './authActions';

const user = getAuthUser();

export function getWorkflowsByHoldingId(holdingId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Workflow/List', { params: { holdingId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function getIncompleteWorkflows(holdingId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Workflow/List/incomplete', { params: { holdingId } }).then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

}

export function save(WorkflowId, phases) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });


    let lstStep = [];

    phases.map((phase, index) => lstStep.push(phase));

    const saveData = {
      WorkflowId,
      LstStep: [...lstStep],
    };

    let request = api.post('WorkflowStep/CreateWokFlowStep', wrapParams(saveData));


    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Dados do Fluxo de Atividade salvos com sucesso');

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('error', '', 'Ocorreu um erro ao salvar os dados do Fluxo de Atividade');

          reject(error.response.data.errors);

        },
      );

    });

  };

}

export function saveIncompleteWorkflow(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    let saveData = {
      companyId: user.context.idCompany,
      name: data.name,
    };

    let request = api.post('Workflow/Create', wrapParams(saveData));

    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Dados do Fluxo de Atividade salvos com sucesso');

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('error', '', 'Ocorreu um erro ao salvar os dados do Fluxo de Atividade');

          reject(error.response.data.errors);

        },
      );

    });

  };

}

export function statusUpdate(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    let request;

    request = api.put('Workflow/UpdateStatus', wrapParams(data));


    return new Promise((resolve, reject) => {

      request.then(
        (response) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('success', '', 'Dados do Usuário salvos com sucesso');

          resolve(response);

        },
        (error) => {

          dispatch({
            type: HIDE_LOADING,
          });

          showToast('error', '', 'Ocorreu um erro ao salvar os dados do Usuário');

          reject(error.response.data.errors);

        },
      );

    });

  };

}

export function deleteWorkflow(workflowId) {

  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,

    });

    return new Promise((resolve, reject) => {

      api.delete('Workflow/Delete', { params: { workflowId } }).then(() => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('success', '', 'Registro de Fluxo de Atividade deletado');
        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        showToast('error', '', 'Ocorreu um erro ao deletar os dados do Fluxo de Atividade');
        reject(error.response.data.errors);

      });

    });

  };

}



// WEBPACK FOOTER //
// ./src/redux/actions/workflowActions.js